import type { TherapistCurrent } from "@/Modules/Models/Domain/Therapist";
import type { TherapistStore } from "../Store";
import type { TherapistUpdateCurrentApiQuery } from "@/Modules/Models/Api/Therapist";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import TherapistApiConnector from "@/Services/TherapyApi/Therapists";

class UpdateTherapistCurrentsActionHandler {
  constructor(
    private readonly therapistStore: TherapistStore,
    private readonly therapistApiConnector = new TherapistApiConnector()
  ) {}

  public async handle(currents: TherapistCurrent[]) {
    try {
      this.therapistStore.isLoading = true;

      const therapistUpdateCurrentsApiQuery: TherapistUpdateCurrentApiQuery[] =
        this.transformTherapistCurrentsToApiQuery(currents);

      await this.therapistApiConnector.updateTherapistCurrents(therapistUpdateCurrentsApiQuery);

      if (this.therapistStore.therapist?.currents) {
        const updatedCurrentUuids = currents.map((current) => current.uuid);

        const updatedCurrents = this.therapistStore.therapist.currents.map((current) => {
          return updatedCurrentUuids.includes(current.uuid)
            ? { ...current, isActive: !current.isActive }
            : current;
        });

        this.therapistStore.therapist.currents = updatedCurrents;

        this.therapistStore.notification = {
          type: NotificationType.SUCCESS,
          code: null,
          message: "",
        };
      }
    } catch (error: unknown) {
      this.therapistStore.notification = {
        type: NotificationType.ERROR,
        code: null,
        message: "settings.configuration.therapeutic_approaches.notification.error",
      };
    } finally {
      this.therapistStore.isLoading = false;
    }
  }

  private transformTherapistCurrentsToApiQuery(currents: TherapistCurrent[]) {
    return currents.map((current) => {
      return {
        uuid: current.uuid,
        is_active: current.isActive,
      };
    });
  }
}

export default UpdateTherapistCurrentsActionHandler;
